import * as React from 'react';
import { classes } from '../../helpers';
import { useTheme } from '../Theme/Theme';
import { style } from './style';
export const Divider = (props) => {
    const theme = useTheme();
    const color = props.color;
    const css = style(color, theme);
    return (React.createElement("div", { style: props.style, className: classes(css.divider, props.children ? css.psuedoWithChild : css.psuedoWithoutChild, props.className) }, props.children));
};
Divider.defaultProps = {
    className: '',
};
//# sourceMappingURL=Divider.js.map